import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { Button as StyledButton } from './styles';

export const Button = forwardRef(({children, ...rest}, ref) => (
    <StyledButton ref={ref} {...rest}>{children}</StyledButton>
));

Button.displayName = 'Button';
Button.propTypes = { children: PropTypes.any };

export default Button;
